export const nanoid = (size = 21) => {
    return Math.random().toString().substring(2);
};
//# sourceMappingURL=utils.js.map